export const getPrefilledText = (prefill: string, value: string, prevValue = '') => {
  if (value.indexOf(prefill) === 0) {
    return value
  } else if (value === '') {
    return prefill
  }
  return prevValue
}
